// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.term-card-container {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}
.term-card-container .terms-card-alert {
  width: 100%;
  margin-bottom: 1rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/screens/BusinessBadesulMicrocreditoRegisterScreen/components/BadesulMicrocreditoBusinessUserDrawer/components/proofOfCivilStatus.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;AAJA;EAMI,WAAA;EACA,8BAAA;AACJ","sourcesContent":[".term-card-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n\n  .terms-card-alert {\n    width: 100%;\n    margin-bottom: 1rem !important;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
